import "./App.css"

function App() {
  return <div className="App">Welcome Dev!</div>
}

export default App
